import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '@/resources/strings/StringKeys';
import { OrganizationOnAzure } from '../../../../generated-client/models';
import { getIsOrgOnTrial } from '@/utils/organization/getIsOrgOnTrial';

const TRIAL_END_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

type OrgFreeTrialAlertProps = {
  organization: OrganizationOnAzure;
};

const OrgFreeTrialAlert = ({ organization }: OrgFreeTrialAlertProps) => {
  const { t } = useTranslation();
  const trialEndTimestamp = organization.trial_end_timestamp;
  const isOnFreeTrial = getIsOrgOnTrial(trialEndTimestamp);
  const trialEndDateLabel = trialEndTimestamp
    ? new Date(trialEndTimestamp).toLocaleDateString('en-US', TRIAL_END_DATE_FORMAT)
    : null;

  if (!isOnFreeTrial || !trialEndDateLabel) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 1, flexShrink: 0, fontSize: 13 }}>
      <AlertTitle sx={{ fontSize: 14 }}>
        {t(StringKeys.ORGANIZATION_ON_FREE_TRIAL_TITLE_UNTIL, {
          trialEndDate: trialEndDateLabel,
        })}
      </AlertTitle>
      {t(StringKeys.ORGANIZATION_ON_FREE_TRIAL_RESPOND_CAPABILITIES)}
    </Alert>
  );
};

export default OrgFreeTrialAlert;
